import { GzCustomTemplateListController } from '../controller/GzCustomTemplateListController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { CustomTemplateListBaseDataProvider, ListItemRenderer } from '../types';
import { SelectOption } from '../../gzSelect/types';

export class GzCustomTemplateListWebComponent extends BaseWebComponentElement {
  private itemRendererFn: ListItemRenderer;
  private gapPx = 0; // gap in px between items
  private columnCount = 0;
  private pageSizeValue = 0;
  private pageSizeOptionsList: SelectOption[] = [];
  private filtersArray: any[] = [];
  private dataProviderRef: CustomTemplateListBaseDataProvider;
  public controller: GzCustomTemplateListController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: GzCustomTemplateListController,
    });
  }

  set gap(gapPx: number) {
    this.gapPx = gapPx;
  }

  get gap(): number {
    return this.gapPx;
  }

  set itemRenderer(itemRendererFn: ListItemRenderer) {
    this.itemRendererFn = itemRendererFn;
  }

  get itemRenderer(): ListItemRenderer {
    return this.itemRendererFn;
  }

  set columns(columnCount: number) {
    this.columnCount = columnCount;
  }

  get columns(): number {
    return this.columnCount;
  }

  set filters(filtersArray: any[]) {
    this.filtersArray = filtersArray;
  }

  get filters(): any[] {
    return this.filtersArray;
  }

  set pageSize(pageSizeValue: number) {
    this.pageSizeValue = pageSizeValue;
  }

  get pageSize(): number {
    return this.pageSizeValue;
  }

  set pageSizeOptions(options: SelectOption[]) {
    this.pageSizeOptionsList = options;
  }

  get pageSizeOptions(): SelectOption[] {
    return this.pageSizeOptionsList;
  }

  set dataProvider(dataProvider: CustomTemplateListBaseDataProvider) {
    this.dataProviderRef = dataProvider;
  }

  get dataProvider(): CustomTemplateListBaseDataProvider {
    return this.dataProviderRef;
  }
}
